import {Component, Inject, OnInit, ViewChild, ElementRef} from '@angular/core';
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import {IdexService} from 'app/idex.service';
import {RegisterSignatureComponent} from 'app/e-signature/register-signature/register-signature.component';
import {TwofactorComponent} from '../twofactor/twofactor.component';
import {TranslateService} from '@ngx-translate/core';
import {Toast} from 'app/shared/toast/toast';
import { DatePipe } from '@angular/common';

declare let EnjoyHint: any;
declare let $: any;
let message, message_dup;

@Component({
   selector: 'app-update-profile',
   templateUrl: './update-profile.component.html',
   styleUrls: ['./update-profile.component.css', '../../../assets/font_stylesheet.css']
})
export class UpdateProfileComponent implements OnInit {

   updateName:boolean

   fNameValue: any;
   lNameValue: any;
   emailValue: any;
   imageSignaturePreview: any;
   imageInitializePreview: any;
   isTwoFacLoginChecked: any;
   isTwoFacSignChecked: any;
   isTwoFacLoginGoogleChecked: any;
   isTwoFacSignGoogleChecked: any;
   verificationGoogleChecked: any;
   errorMessage: string;
   signatureId: string;
   initialId: string;
   requireInputMessage: string;
   isNotifyTaskCompleted: any;
   isNotifyTasks: any;
   includeName: any;
   includeDate: any;
   hasSignature: any;
   hasInitial: any;
   currentDate: Date;
   private registerSignDialog: MatDialogRef<RegisterSignatureComponent>;
   private twofactor: MatDialogRef<TwofactorComponent>;
   @ViewChild('canvasOriginal', { static: true }) public canvasOriginal: ElementRef;
   @ViewChild('canvasPatternTmp', { static: true }) public canvasPatternTmp: ElementRef;
   error:any
   isInvalid:boolean

   constructor(@Inject(MAT_DIALOG_DATA) private data: any,
               private dialog: MatDialog,
               public service: IdexService,
               private dialogRef: MatDialogRef<UpdateProfileComponent>,
               public toast: Toast,
               public translate: TranslateService) {
   }

   ngOnInit() {
      const token = this.service.user.token;
      const splitName = this.service.user.name.trim().split(' ', 3); //check name from alfresco
      this.fNameValue = splitName[0];
      if(splitName[1] != null){
         this.lNameValue = splitName[1];
      }
      this.emailValue = this.service.user.email

      if(!this.updateName){
      this.service.getProfile()
         .subscribe((data: any) => {
            this.currentDate = new Date();
            this.isTwoFacLoginChecked = data.isTwoFactorLogin;
            this.isTwoFacSignChecked = data.isTwoFactorSign;
            this.signatureId = data.signatureId;
            this.initialId = data.initialId;
            this.isTwoFacLoginGoogleChecked = data.isTwoFactorLoginGoogle;
            this.isTwoFacSignGoogleChecked = data.isTwoFactorSignGoogle;
            this.verificationGoogleChecked = data.verificationGoogle;
            this.isNotifyTasks = data.isNotifyTasks;
            this.isNotifyTaskCompleted = data.isNotifyTaskCompleted;
            this.includeName = data.includeName;
            this.includeDate = data.includeDate;
            this.hasSignature = data.hasSignature;
            this.hasInitial = data.hasInitial;
            if (data.hasSignature) {
               const url = this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=' + this.includeName + '&isChkDate=' + this.includeDate + '&init=false';
               this.service.toDataURL(url, (dataUrl) => {
                  document.getElementById('pSignatureShow').setAttribute('src', dataUrl);
                  this.initialSignature();
               });
            } else {
               document.getElementById('pSignatureShow').setAttribute('src', 'assets/images/no_signature.png');
            }
            if (data.hasInitial) {
               const url = this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=false&isChkDate=false&init=true';
               this.service.toDataURL(url, function(dataUrl) {
                  document.getElementById('pInitialShow').setAttribute('src', dataUrl);
               });
            } else {
               document.getElementById('pInitialShow').setAttribute('src', 'assets/images/no_initials.png');
            }
            if (localStorage.getItem('first_update_profile_open') !== 'true') {
               this.onStartTutorial();
               localStorage.setItem('first_update_profile_open', 'true');
            }
         }, error => {
            this.errorMessage = error;
            localStorage.removeItem('first_update_profile_open');
         });
      this.data.translate.get('alert.inputRequired').subscribe((msg) => {
         this.requireInputMessage = msg;
         message = msg;
      });
      this.data.translate.get('alert.not-match').subscribe((msg_dup) => {
         this.requireInputMessage = msg_dup;
         message_dup = msg_dup;
      });
      this.InvalidMsg();
    }

   }

   checkPattern(fName,lName){
      if (fName !== undefined && lName !== undefined) {
         const value = `${fName.trim()}${lName.trim()}`

         if(fName.trim() === '' || lName.trim()  === ''){
            this.error = '';
            this.isInvalid = true;
            return
         }

         if (/[<|>\\\/:?*"]/g.test(value)) {
            this.translate.get('alert.create_folder_error').subscribe(s => {
               this.error = s;
            });
            this.isInvalid = true;
         } else {
            this.translate.get('alert.empty').subscribe(s => {
               this.error = s;
               this.isInvalid = false;
            });
         }
   }
}

   openUpdateSignature() {
      this.registerSignDialog = this.dialog.open(RegisterSignatureComponent, {
         disableClose: true,
         data: this
      });
      this.imageSignaturePreview = document.getElementById('pSignatureShow').getAttribute('src');
      this.imageInitializePreview = document.getElementById('pInitialShow').getAttribute('src');
      this.registerSignDialog.componentInstance.signatureId = this.signatureId;
      this.registerSignDialog.componentInstance.initialId = this.initialId;
      this.registerSignDialog.componentInstance.imageSignatureOriginal = this.imageSignaturePreview;
      this.registerSignDialog.componentInstance.imageInitOriginal = this.imageInitializePreview;
      this.registerSignDialog.componentInstance.fullNameValue = this.fNameValue + ' ' + this.lNameValue;
      this.registerSignDialog.componentInstance.includeName = this.includeName;
      this.registerSignDialog.componentInstance.includeDate = this.includeDate;
      this.registerSignDialog.componentInstance.hasSignature = this.hasSignature;
      this.registerSignDialog.componentInstance.hasInitial = this.hasInitial;

      this.registerSignDialog.afterClosed().subscribe(result => {
         if (result) {
            this.service.getProfile()
               .subscribe((data: any) => {
                  this.hasSignature = data.hasSignature;
                  this.hasInitial = data.hasInitial;
                  this.data.component.imageSignaturePreview = this.registerSignDialog.componentInstance.imageSignaturePreview;
                  this.data.component.imageInitializePreview = this.registerSignDialog.componentInstance.imageInitializePreview;
               });
            this.includeName = this.registerSignDialog.componentInstance.includeName;
            this.includeDate = this.registerSignDialog.componentInstance.includeDate;
            this.service.toDataURL(this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=' + this.includeName + '&isChkDate=' + this.includeDate + '&init=false', (dataUrl) => {
               document.getElementById('pSignatureShow').setAttribute('src', dataUrl);
               document.getElementById('signatureDdShow').setAttribute('src', dataUrl);
               this.imageSignaturePreview = dataUrl;
               this.initialSignature();
            });
            this.service.toDataURL(this.service.url + '/signature?version=' + Date.now() + '&lastmod=' + Date.now() + '&isChkName=false&isChkDate=false&init=true', function(dataUrl) {
               document.getElementById('pInitialShow').setAttribute('src', dataUrl);
               document.getElementById('initDdShow').setAttribute('src', dataUrl);
            });
         }
      });
   }

   initialSignature(){
      let img = document.getElementById('pSignatureShow');
      let imgTmp = new Image();
      // img2.width = 200;
      // img2.width = 50;
      imgTmp.onload = () => {
         let canvas = this.canvasOriginal.nativeElement;
         let context = canvas.getContext("2d");
         var hRatio = canvas.width / imgTmp.width;
         var vRatio = canvas.height / imgTmp.height;
         var ratio = Math.min(hRatio, vRatio);
         var centerShiftX = ( canvas.width - imgTmp.width*ratio ) / 2;
         var centerShiftY = ( canvas.height - imgTmp.height*ratio ) / 2;
         context.clearRect(0, 0, canvas.width, canvas.height);
         context.drawImage(imgTmp,0,0, imgTmp.width, imgTmp.height, centerShiftX, centerShiftY,
            (imgTmp.width) * ratio, imgTmp.height * ratio);
         const tmp = this.editPatternCanvas(this.canvasOriginal.nativeElement, 'original');

         document.getElementById('pSignatureShow').setAttribute('src', tmp.toDataURL());
         this.imageSignaturePreview = tmp.toDataURL();
      }
      imgTmp.src =img.getAttribute('src');
   }

   editPatternCanvas(oldCanvas: HTMLCanvasElement , type: string) {
      let canvasTmp = this.canvasPatternTmp.nativeElement;
      const ctx = canvasTmp.getContext('2d');
      ctx.clearRect(0, 0, canvasTmp.width, canvasTmp.height);

      if ((this.includeName || this.includeDate) && type !== 'init') {
         canvasTmp.width = oldCanvas.width + 75;
         canvasTmp.height = oldCanvas.height;

         ctx.drawImage(oldCanvas, -10, 0);

         const datepipe: DatePipe = new DatePipe('en-US');
         const formatDate = datepipe.transform(this.currentDate, 'dd/MM/yyyy');
         const formatTime = datepipe.transform(this.currentDate,  'HH:mm:ss Z');

         ctx.font = '200 8px Arial';
         const width = ctx.measureText(formatDate + ' ' + formatTime).width - 10;

         const x = canvasTmp.width - width;
         let y = canvasTmp.height / 2;
         if (this.includeName && this.includeDate) {
            y -= 10;
         }

         const lineSpace = 8;

         this.fillIncludeText(ctx, x, y, lineSpace, formatDate, formatTime);
      } else {
         canvasTmp.width = oldCanvas.width;
         canvasTmp.height = oldCanvas.height;
         ctx.drawImage(oldCanvas, 0, 0);
      }
      return canvasTmp;
  }

  fillIncludeText(ctx: any, x: number, y: number, lineSpace: number, date: string, time: string) {
      const user = JSON.parse(localStorage.getItem('idex-user'));
      if (this.includeName) {
         ctx.fillText('Digital signed by', x, y);
         y = y + lineSpace;
         let limit = 19;
         if (user.name.length <= limit) {
            ctx.fillText(user.name, x, y);
            y = y + lineSpace;
         } else {
            let len = user.name.length;
            let startIndex = 0;
            let endIndex = len - 1;
            while(startIndex <= endIndex){
               let str = user.name.substring(startIndex,startIndex + limit);
               startIndex += limit;
               ctx.fillText(str, x, y);
               y = y + lineSpace;
            }
         }
      }
      if (this.includeDate) {
         ctx.fillText('Date: ' + date, x, y);
         y = y +  lineSpace;
         ctx.fillText(time, x, y);
      }
   }

   updateProfileName(fname: any, lname: any){
      const firstName = fname.value;
      const lastName = lname.value;

      this.service.updateName(firstName,lastName).subscribe((response) => {
         this.dialogRef.close(true);
         this.toast.success(response);
         this.service.user.name = firstName + ' ' + lastName;
      }, err =>{
         this.dialogRef.close(false);
         this.toast.error(err);
      });
   }

   updateProfile(fname: any, lname: any, isTwoFacLogin: any, isTwoFacSign: any, isNotify: any, isNotifyCompleted: any, isIncludeName: any, isIncludeDate: any) {
      const firstName = fname.value;
      const lastName = lname.value;
      const isTwoFactorLogin = isTwoFacLogin.checked;
      const isTwoFactorSign = isTwoFacSign.checked;
      const notify = isNotify.checked;
      const notifyCompleted = isNotifyCompleted.checked;
      const isTwoFactorGoogle = (this.isTwoFacLoginGoogleChecked || this.isTwoFacSignGoogleChecked);
      const includeName = isIncludeName.checked;
      const includeDate = isIncludeDate.checked;
      let isCallUpdate = false;
      let isEnableLoginGoogle = false;
      let isEnableSignGoogle = false;
      let isVerifyGoogle = false;

      if (isTwoFactorLogin || isTwoFactorSign) {
         if (isTwoFactorGoogle && !this.verificationGoogleChecked) {
            this.twofactor = this.dialog.open(TwofactorComponent, {
               disableClose: true,
               data: {token: null, qrCodeUrl: this.service.user.qrCodeUrl, mode: 'update'}
            });
            this.twofactor.afterClosed().subscribe(result => {
               if (result === 200) {
                  isEnableLoginGoogle = this.isTwoFacLoginGoogleChecked;
                  isEnableSignGoogle = this.isTwoFacSignGoogleChecked;
                  isVerifyGoogle = true;

                  this.callUpdateProfile(firstName, lastName, isTwoFactorLogin, isTwoFactorSign,
                     isEnableLoginGoogle, isEnableSignGoogle, isVerifyGoogle,
                     notify, notifyCompleted, includeName, includeDate);
               } else {
                  this.isTwoFacLoginGoogleChecked = false;
                  this.isTwoFacSignGoogleChecked = false;
               }
            });
         } else {
            isCallUpdate = true;
            isEnableLoginGoogle = this.isTwoFacLoginGoogleChecked;
            isEnableSignGoogle = this.isTwoFacSignGoogleChecked;
            isVerifyGoogle = this.verificationGoogleChecked;
         }
      } else {
         isCallUpdate = true;
         isEnableLoginGoogle = false;
         isEnableSignGoogle = false;
         isVerifyGoogle = this.verificationGoogleChecked;
      }

      if (isCallUpdate) {
         this.callUpdateProfile(firstName, lastName, isTwoFactorLogin, isTwoFactorSign,
            isEnableLoginGoogle, isEnableSignGoogle, isVerifyGoogle,
            notify, notifyCompleted, includeName, includeDate);
      }
   }

   callUpdateProfile(firstName: any, lastName: any, isTwoFactorLogin: any, isTwoFactorSign: any,
                     isTwoFacLoginGoogleChecked: boolean, isTwoFacSignGoogleChecked: boolean, verificationGoogleChecked: boolean,
                     isNotify: boolean, isNotifyCompleted: boolean, isIncludeName: boolean, isIncludeDate: boolean) {
      this.service.user.name = firstName + ' ' + lastName;
      this.service.updateProfile(firstName, lastName, isTwoFactorLogin, isTwoFactorSign,
         isTwoFacLoginGoogleChecked, isTwoFacSignGoogleChecked, verificationGoogleChecked,
         isNotify, isNotifyCompleted, isIncludeName, isIncludeDate)
         .subscribe((response) => {
            this.dialogRef.close();
            this.toast.success(response);
         });
   }

   /**setCustomValidity not only sets the message, but also marks
    * the field as invalid. In order to see whether the field really is
    * invalid, we have to remove the message first
    **/

   InvalidMsg() {
      $('#form input[type=text]').on('change invalid', function () {
         const textfield = $(this).get(0);
         const contactName = textfield.value.trim();
         textfield.setCustomValidity('');
         if ((/[<|>!\\\/~+#$&()\-_=,:?*;'."%^{}@[\]]/g.test(contactName))) {
            textfield.setCustomValidity(message_dup);
            setTimeout(function () {
               textfield.setCustomValidity(' ');
            }, 1000);
         } else if (contactName === '') {
            textfield.setCustomValidity(message);
            setTimeout(function () {
               textfield.setCustomValidity(' ');
            }, 1000);
         }
      });
   }

   onStartTutorial(): void {
      this.translate.get('tutorial').subscribe((msg) => {
         const enjoyhint_instance = new EnjoyHint({});
         const enjoyhint_script_steps = [
            {
               'next #twofact-login-hint': msg.updateProfile.twoFactLogin,
               'nextButton': {text: msg.next},
               'skipButton': {text: msg.close},
            },
            {
               'next #twofact-sign-hint': msg.updateProfile.twoFactSign,
               'nextButton': {text: msg.next},
               'skipButton': {text: msg.close},
            },
            {
               'next #notify': msg.updateProfile.notifyReceive,
               'nextButton': {text: msg.next},
               'skipButton': {text: msg.close},
            },
            {
               'next #notifyCompleted': msg.updateProfile.notifyCompleted,
               'nextButton': {text: msg.next},
               'skipButton': {text: msg.close},
            },
            {
               'next #sign-btn': msg.updateProfile.sign,
               'nextButton': {text: msg.close},
               'showSkip': false
            }
         ];
         enjoyhint_instance.set(enjoyhint_script_steps);
         enjoyhint_instance.run();
      });
   }
}
